import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";

export default createQueryGroup(({ api }) => ({
  list: () =>
    queryOptions({
      queryKey: ["nursingQuestionSettings", "list"],
      queryFn: () => api.get("./nursing_questions_settings", {}),
    }),
}));
